import type {RequestBodyValue} from '../types/request';

export const isFormDataBody = (
  body: RequestBodyValue | undefined,
): body is FormData => {
  if (typeof FormData === 'undefined') {
    return false;
  }

  return body instanceof FormData;
};

export const isBodyInitValue = (
  body: RequestBodyValue | undefined,
): body is Exclude<RequestInit['body'], null | undefined> => {
  if (body === undefined || body === null) {
    return false;
  }

  if (typeof body === 'string') {
    return true;
  }

  if (
    typeof URLSearchParams !== 'undefined' &&
    body instanceof URLSearchParams
  ) {
    return true;
  }

  if (typeof Blob !== 'undefined' && body instanceof Blob) {
    return true;
  }

  if (typeof ArrayBuffer !== 'undefined' && body instanceof ArrayBuffer) {
    return true;
  }

  if (ArrayBuffer.isView(body)) {
    return true;
  }

  if (typeof ReadableStream !== 'undefined' && body instanceof ReadableStream) {
    return true;
  }

  return isFormDataBody(body);
};

/** Converts the extended `RequestBodyValue` to a native `BodyInit` — plain objects/arrays are JSON-stringified, everything else passes through. */
export const serializeRequestBody = (
  body: RequestBodyValue | undefined,
): BodyInit | undefined => {
  if (body === undefined || body === null) {
    return undefined;
  }

  if (isBodyInitValue(body)) {
    return body;
  }

  return JSON.stringify(body);
};
